module.exports = __webpack_public_path__ + "f27c3aa15d9b309685e515a1bb0c008d.jpg";